import { Folders } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useProjects } from '../../api/projects';
import { useIsAdmin } from '../../auth/useAuth';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { SkeletonLoader } from '../../components/SkeletonLoader';
import { Table } from '../../components/Table';
import { formatRelativeTime } from '../../utils/format';
import shared from '../shared.module.css';

export function ProjectListPage() {
	const navigate = useNavigate();
	const isAdmin = useIsAdmin();
	const { data: projects, isLoading, error } = useProjects();

	const columns = [
		{ key: 'name', label: 'Name' },
		{ key: 'slug', label: 'Slug', mono: true },
		{ key: 'origins', label: 'Origins' },
		{ key: 'created', label: 'Created' },
	];

	return (
		<div>
			<PageHeader
				title="Projects"
				actions={
					isAdmin ? (
						<Button variant="primary" onClick={() => navigate('/projects/new')}>
							New Project
						</Button>
					) : undefined
				}
			/>

			<div className={shared.content}>
				<Card>
					{error ? (
						<p className={shared.errorMessage}>
							{error instanceof Error ? error.message : 'Failed to load projects'}
						</p>
					) : (
						<Table>
							<Table.Header columns={columns} />
							<Table.Body>
								{isLoading ? (
									<SkeletonLoader rows={4} columns={4} />
								) : !projects || projects.length === 0 ? (
									<tr>
										<td colSpan={4}>
											<EmptyState
												icon={Folders}
												title="No projects yet"
												description="Create your first project to get started."
												action={
													isAdmin
														? {
																label: 'Create your first project',
																onClick: () => navigate('/projects/new'),
															}
														: undefined
												}
											/>
										</td>
									</tr>
								) : (
									projects.map((project) => (
										<Table.Row key={project.id} onClick={() => navigate(`/projects/${project.id}`)}>
											<Table.Cell>{project.name}</Table.Cell>
											<Table.Cell mono>{project.slug}</Table.Cell>
											<Table.Cell>{project.allowed_origins.length}</Table.Cell>
											<Table.Cell mono>{formatRelativeTime(project.created_at)}</Table.Cell>
										</Table.Row>
									))
								)}
							</Table.Body>
						</Table>
					)}
				</Card>
			</div>
		</div>
	);
}
